import { TEST_PREVIEW } from '../constants/actionTypes'

const init = {
    testPreviewData: {},
}

export default (state = init, action) => {
    switch (action.type) {
        case TEST_PREVIEW:
            return {
                ...state,
                testPreviewData: action.payload,
            }
        default:
            return state
    }
}
